import React, { useState, useEffect } from "react";
import "./TimeProgressBar.css";

const TimeProgressBar = ({ totalTime, interval }) => {
  const [currentTime, setCurrentTime] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime((prevTime) => {
        const newTime = prevTime + interval;
        if (newTime > totalTime) {
          clearInterval(timer);
          return totalTime;
        } else {
          return newTime;
        }
      });
    }, interval);

    return () => clearInterval(timer);
  }, [interval, totalTime]);

  const progress = (currentTime / totalTime) * 100;
  const timeRemaining = (totalTime - currentTime) / 1000;

  return (
    <div className="time_progress_bar_container">
      <div className="time_progress_bar_setting_gif_container">
        <img src="/Settings.gif" alt="Book Animation" />
      </div>

      <div className="time_progress_bar">
        <div className="time_progress_bar_fill" style={{ width: `${progress}%` }}></div>
      </div>
      <p className="mt_2">Generating... {"( " + timeRemaining + "s )"}</p>
    </div>
  );
};

export default TimeProgressBar;
